module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAARklEQVQ4y2P4jwQ+MAww7wADDNgPDp79/z+Dhff/AP8g4TH/B7rs///BwAM6ChpUA88DumxQ8f4jh9lA8gY8F8N5g6esAwBWarwzvE5VbAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xM1QxNToyNjo0MyswOTowMHkN2/UAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjYrMDk6MDDL5wzeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00581_100x100.png
// module id = t49f
// module chunks = 0